import { render, staticRenderFns } from "./PlatformPromotions.vue?vue&type=template&id=3633e409&"
import script from "./PlatformPromotions.vue?vue&type=script&lang=js&"
export * from "./PlatformPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports